import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type FormInputErrorsProps = {
  className?: string;
  errors?: string[];
};
export default function FormInputErrors(t0) {
  const $ = _c(7);
  const {
    className,
    errors: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const errors = t2;
  if (!errors.length) {
    return null;
  }
  let t3;
  if ($[2] !== errors) {
    t3 = errors.map(_temp);
    $[2] = errors;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== className || $[5] !== t3) {
    t4 = <div className={className}>{t3}</div>;
    $[4] = className;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(error, index) {
  return <p key={error} data-testid="FormInputError" data-form-error="" className={cx("ml-1 text-sm text-red-600", index === 0 && "mt-1")}>{error}</p>;
}